import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, formatDateTime } from "@/lib/api";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const TYPES = [["bank", "Deposited to bank"], ["kept", "Kept as cash"], ["used", "Used"]];

export const ClearOfficeCash = ({ officeTotal, onDone }) => {
  const [v, setV] = useState({ bank: String(officeTotal || ""), kept: "", used: "", note: "" });
  const [busy, setBusy] = useState(false);
  const sum = TYPES.reduce((s, [k]) => s + (parseInt(v[k], 10) || 0), 0);
  const ok = sum === officeTotal;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/cash/admin/clear", { bank: parseInt(v.bank, 10) || 0, kept: parseInt(v.kept, 10) || 0, used: parseInt(v.used, 10) || 0, note: v.note });
      toast.success("Office cash cleared"); onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not clear"); } finally { setBusy(false); }
  };
  if (!officeTotal) return <p className="text-sm text-slate-500" data-testid="cash-clear-empty">Office cash is empty.</p>;
  return (
    <div className="rounded-xl border border-green-200 bg-white p-4 space-y-3" data-testid="cash-clear-form">
      <p className="text-sm text-slate-700">Split <b>{inr(officeTotal)}</b> by what happened to it:</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {TYPES.map(([k, label]) => (
          <label key={k} className="text-xs font-semibold text-slate-600 space-y-1">
            <span>{label}</span>
            <Input type="number" min="0" inputMode="numeric" value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`cash-clear-${k}`} />
          </label>
        ))}
      </div>
      <Input placeholder="Note (optional)" value={v.note} onChange={(e) => setV({ ...v, note: e.target.value })} data-testid="cash-clear-note" />
      <div className="flex flex-wrap items-center gap-3">
        <Button onClick={submit} disabled={!ok || busy} data-testid="cash-clear-submit">Clear office cash</Button>
        <span className={`text-xs font-semibold ${ok ? "text-green-700" : "text-red-600"}`} data-testid="cash-clear-sum">Total {inr(sum)} of {inr(officeTotal)}</span>
      </div>
    </div>
  );
};

export const ClearanceHistory = ({ rows }) => rows.length === 0 ? <p className="text-sm text-slate-500">No clearances yet.</p> : (
  <div className="rounded-xl border border-slate-200 bg-white divide-y divide-slate-100" data-testid="cash-clearances">
    {rows.map((c) => (
      <div key={c.id} className="p-3 text-sm flex flex-wrap items-center justify-between gap-2" data-testid={`cash-clearance-${c.id}`}>
        <span><b>{inr(c.total)}</b> · {c.count} entr{c.count === 1 ? "y" : "ies"} · <span className="text-xs text-slate-500">{formatDateTime(c.created_at)}</span>{c.note ? <span className="text-xs text-slate-500"> · {c.note}</span> : null}</span>
        <span className="text-xs">Bank {inr(c.bank)} · Kept {inr(c.kept)} · Used {inr(c.used)}</span>
      </div>
    ))}
  </div>
);
